const ClientStatus = {
    Archived: 0,
    Active: 1,
    Pending: 2,
    Deleted: 3,
    ActivePartner: 4
}
export default ClientStatus;